(ns runtime-resolve.core
  (:refer-clojure :exclude [resolve])
  (:require
    [clojure.string :refer [replace]]
    )
  )

;; the purpose of the module is to provide all the clojure namespace stuff
;; that clojurescript core does not provide... where normally clojure would
;; use its internal namespacing system, we're going to abuse javascript interop
;; and atoms to make the same thing happen in a way that's compatible with
;; :advanced closure compilation
(defn cljns->jsns
  "Convert a clojurescript symbol, such as 'my-foo.bar/my-func into a javascript
  function reference my_foo.bar.my_func. This is extremely stupid and unsafe, but
  we need it for use in dynamic resolution of cljs namespace functions."
  [sym]
  (-> sym
      str
      (replace #"/" ".")
      (replace #"-" "_")))

(defn resolve
  "Dynamically resolve the given namespace symbol by digging into the global
  javascript environment. Here be dragons, be wary."
  [sym]
  (js/eval (cljns->jsns sym)))
